import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ coords, text, id, textSize, colors, textCoordsX, textCoordsY, size, onClick, textColor }) => {
	const circleSize = size === 'small' ? { cx: "13", cy: "13", r: "13" } : { cx: "18", cy: "18", r: "18" };
	const smallCircleRadius = size === 'small' ? "10" : "14";
	let labelRef = React.createRef();

	return (
		<g
			id={id || null}
			transform={`translate(${coords})`}
			className="label"
			onClick={onClick ? event => onClick(event, labelRef) : null}
			ref={ref => {labelRef = ref}}
		>
			<circle fill={colors[0]} fillRule="evenodd" cx={circleSize.cx} cy={circleSize.cy} r={circleSize.r}/>
			<circle fill={colors[1]} fillRule="evenodd" cx={circleSize.cx} cy={circleSize.cy} r={smallCircleRadius}/>
			<text
				fontFamily="MapFont, Open Sans, sans-serif"
				fontSize={textSize || "14"}
				fontWeight="normal"
				fill={textColor || "#FFFFFF"}
			>
				<tspan
					x={textCoordsX}
					y={textCoordsY}
				>
					{text}
				</tspan>
			</text>
		</g>
	)
};

Label.defaultProps = {
	textCoordsX: '7.80175781',
	textCoordsY: '22',
	size: 'normal',
};

Label.propTypes = {
	coords: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	textCoordsX: PropTypes.string,
	textCoordsY: PropTypes.string,
	size: PropTypes.oneOf([
		'normal',
		'small'
	])
};

export default Label;
